module.exports = __webpack_public_path__ + "static/media/KZ.130a3907.svg";